import React, { useCallback, useEffect, useState, useRef } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import image from "../assets/images/burningCup.png";
import { getAllMentors } from "../utils";

function FindMentor(props) {
  const [mentors, setmentors] = useState([]);
  const [textSearch, setTextSearch] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const search = useRef();
  const [loading, setLoading] = useState(false);
  const fakeData = [1, 2, 3, 4, 5, 6, 7, 8];

  // const applyFilters = useDebouncedCallback((value, type) => {
  //   getAllMentors(value, type)
  //     .then((data) => setmentors(data))
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // }, 1000);

  const clearFilters = () => {
    setFiltersApplied(false);
    search.current.value = "";
    let el = document.getElementById("interest");
    let el2 = document.getElementById("interests");
    el.value = "default";
    el2.value = "default";
    let data = JSON.parse(sessionStorage.getItem("mentorData"));
    setmentors(data);
  };

  const applyFilters = useCallback((input, type) => {
    input ? setFiltersApplied(true) : setFiltersApplied(false);
    if (sessionStorage.getItem("mentorData") == null) {
      getAllMentors();
    } else {
      let data = JSON.parse(sessionStorage.getItem("mentorData"));
      setmentors(data);
      if (type === "name") {
        let results = data.filter((doc) =>
          doc[type].toLowerCase().includes(input.toLowerCase())
        );
        setmentors(results);
      } else if (type === "topics") {
        const flattenArray = (val) => {
          let result = [];

          if (!Array.isArray(val)) {
            return val;
          }

          for (let data of val) {
            result = result.concat(flattenArray(data));
          }

          return result;
        };
        let results = data.filter((doc) => {
          let val = doc.topics;
          if (flattenArray(val).includes(input)) {
            return true;
          }
          return "";
        });
        setmentors(results);
      } else {
        let results = data.filter((doc) => {
          if (doc.interest.includes(type)) {
            return true;
          }
          return "";
        });
        setmentors(results);
      }
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    if (sessionStorage.getItem("mentorData") == null) {
      getAllMentors()
        .then((data) => {
          setLoading(false);
          setmentors(data);
          sessionStorage.setItem("mentorData", JSON.stringify(data));
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setLoading(false);
      setmentors(JSON.parse(sessionStorage.getItem("mentorData")));
    }

    if (props.location.state) {
      if (
        ["Career advice", "Interview tips", "Open source"].includes(
          props.location.state
        )
      ) {
        applyFilters(props.location.state, "topics");
      } else {
        applyFilters(props.location.state, "name");
        setTextSearch(props.location.state);
      }
    }
  }, [applyFilters, props]);

  return (
    <div>
      <Header />

      <div className="container  mx-auto px-4 sm:px-2 py-16">
        <div className="hero">
          <div className="flex flex-col items-center justify-center text-center">
            <h1 className="font-semibold text-4xl text-gray-900">
              Search Mentors
            </h1>
          </div>
          <div className="sm:flex justify-start pt-8 items-center">
            <div
              className="bg-white flex items-center sm:w-1/3 mb-2 sm:mb-0 block
                          w-full
                          py-1
                          text-base
                          placeholder-gray-300
                          transition
                          duration-500
                          ease-in-out
                          transform
                          border border-transparent
                          rounded-lg
                          text-neutral-600
                          bg-gray-100
                          focus:outline-none
                          focus:border-transparent
                          focus:ring-2
                          focus:ring-white
                          focus:ring-offset-2
                          focus:ring-offset-gray-300"
            >
              <div className="outline-none focus:outline-none">
                <svg
                  className="ml-6 w-5 text-gray-600 h-5 cursor-pointer"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  onClick={clearFilters}
                >
                  <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>
              <input
                type="search"
                name="searchMentor"
                placeholder="Search for a Mentor"
                ref={search}
                defaultValue={textSearch}
                onChange={(e) => applyFilters(e.target.value, "name")}
                className="w-full text-sm bg-transparent border-transparent rounded-xl focus:border-transparent focus:ring-0"
              />
            </div>
            <div class="relative inline-flex items-center sm:ml-4 mb-2 sm:mb-0">
              <select
                name="interests"
                id="interests"
                x-model="image_type"
                defaultValue={props.location.state}
                onChange={(e) =>
                  applyFilters(
                    e.target.value.charAt(0).toUpperCase() +
                      e.target.value.substr(1).toLowerCase(),
                    "topics"
                  )
                }
                className="block
                w-full
                py-3
                text-base
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                border border-transparent
                rounded-lg
                text-neutral-600
                bg-gray-100
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300"
              >
                <option value="default">Topic of interest</option>
                <option value="Career advice">Career advice</option>
                <option value="Interview tips">Interview tips</option>
                <option value="Getting most out of internships">
                  Getting most out of internships
                </option>
                <option value="Portfolio">Portfolio review</option>
                <option value="Public speaking">Public speaking</option>
                <option value="Open source">Open source</option>
                <option value="Tech communities">Tech communities</option>
                <option value="Developer career path">
                  Developer career path
                </option>
                <option value="Building scalable products">
                  Building scalable products
                </option>
              </select>
            </div>

            <div class="relative inline-flex justify-start items-center sm:ml-4">
              <select
                name="interest"
                id="interest"
                x-model="image_type"
                onChange={(e) =>
                  applyFilters(
                    e.target.value.charAt(0).toUpperCase() +
                      e.target.value.substr(1).toLowerCase(),
                    e.target.value
                  )
                }
                className="block
                w-full
                py-3
                text-base
                placeholder-gray-300
                transition
                duration-500
                ease-in-out
                transform
                border border-transparent
                rounded-lg
                text-neutral-600
                bg-gray-100
                focus:outline-none
                focus:border-transparent
                focus:ring-2
                focus:ring-white
                focus:ring-offset-2
                focus:ring-offset-gray-300"
              >
                <option value="default">Expertise</option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
                <option value="React.js">React.js</option>
                <option value="Vue.js">Vue.js</option>
                <option value="Java">Java</option>
                <option value="Spring Boot">Spring Boot</option>
                <option value="Machine learning">Machine learning</option>
                <option value="Scalable systems">Scalable systems</option>
                <option value="Next.js">Next.js</option>
                <option value="Nuxt.js">Nuxt.js</option>
                <option value="Cyber security">Cyber security</option>
                <option value="AR/VR">AR/VR</option>
                <option value="AWS">AWS</option>
                <option value="GCP">GCP</option>
                <option value="SQL">SQL</option>
                <option value="MongoDB">MongoDB</option>
                <option value="Firebase">Firebase</option>
                <option value="GraphQL">GraphQL</option>
                <option value="Node.js">Node.js</option>
                <option value="GoLang">GoLang</option>
                <option value="Python">Python</option>
                <option value="Git">Git</option>
                <option value="Unity">Unity</option>
              </select>
            </div>
            {filtersApplied && (
              <button
                onClick={clearFilters}
                class="px-5 py-3 ml-4 rounded-xl text-sm font-medium text-white bg-gray-400 hover:bg-gray-500 focus:outline-none transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 inline-flex items-center mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Clear filters
              </button>
            )}
          </div>

          {filtersApplied && (
            <div>
              <p className="mt-8 text-gray-400">
                Showing {mentors.length} results
              </p>
            </div>
          )}

          <div className="py-8 sm:py-10 grid grid-cols-1 md:grid-cols-4 gap-4 w-full">
            {mentors && mentors.length ? (
              mentors.map((mentorData) => (
                <div
                  key={`${mentorData.username}`}
                  className="flex flex-wrap -m-4"
                >
                  <div className="p-4 sm: w-full h-full">
                    <a
                      href={`/mentor/${mentorData.username}`}
                      className="block object-cover rounded-lg p-5 transform transition-all duration-300 scale-100 hover:scale-95 h-full"
                      style={{
                        backgroundImage: `url(${mentorData.profilePic})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        boxShadow: "inset 0 -10em 5em -5em #000000",
                        transform:
                          "rotate3d(0, 0, 1, 20deg) scale3d(1, 0.6, 1}",
                      }}
                    >
                      <div className="h-72"></div>
                      <h2 className="text-white text-2xl font-bold leading-tight mb-1 pr-5 bg-blend-darken">
                        {mentorData.name}
                      </h2>
                      <div className="text-sm text-white font-bold mb-2 ">
                        {mentorData.company}
                      </div>
                      <div className="flex w-80 sm:w-full items-center text-sm text-white font-medium bottom-end truncate">
                        <div className="flex-1 flex items-center">
                          <div className="flex ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                              />
                            </svg>
                            <h1 className="ml-2 text-sm">
                              Ask me about{" "}
                              <span className="font-medium">
                                {mentorData.interest.join(", ")}
                              </span>
                            </h1>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              ))
            ) : loading ? (
              fakeData.map((i) => (
                <div className="p-4 sm: w-full h-full rounded-xl bg-gray-200 animate-pulse">
                  <div className="block transform transition-all duration-300 scale-100 hover:scale-95 h-full">
                    <div className="h-72"></div>
                    <div className="bg-gray-300 py-2.5 text-gray-300 rounded-lg animate-pulse"></div>
                    <div className="py-2 bg-gray-300 font-bold mt-2 w-1/2 mb-2"></div>
                    <div className="flex w-80 sm:w-full items-center text-sm text-white font-medium bottom-end truncate">
                      <div className="flex-1 flex items-center">
                        <div className="flex">
                          <div></div>
                          <h1 className="ml-2 text-sm bg-gray-400">
                            <span className="font-medium"></span>
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div class="relative bg-red mx-4">
                  <div class="fixed flex justify-center">
                    <div class="w-32 h-32 bg-blue"></div>
                  </div>
                </div>

                <div class="float-right relative w-60 h-40 bg-red mx-4 ml-16 sm:ml-48 mb-24">
                  <div class=" flex items-center justify-center">
                    <div class="w-60 h-60 bg-blue flex-col justify-center items-center text-center">
                      <img src={image} alt="no results found" />
                      <p className="text-xl text-gray-600 font-medium">
                        No results to show
                      </p>
                      <p className="text-sm text-gray-500 mt-1">
                        There weren't any profile matching your search
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* {mentors.length > 8 && (
            <button class="bg-gradient-to-r from-blue-500 to-blue-900 focus:outline-none rounded-md py-3 px-6 mx-auto block text-white transition duration-500 ease-in-out">
              Load more mentors
            </button>
          )} */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FindMentor;
